/**
 * KAN-740: автоподбор прокси справочника по префиксу метки в мастере
 * подключения аккаунта. Подходит рабочий прокси (последняя проверка ok),
 * у которого страна совпадает с кодом префикса без учёта регистра; из таких
 * берётся наименее загруженный (меньше аккаунтов), при равенстве первый по списку.
 */
import type { TelegramProxy } from '@/types/telegramProxy';

function norm(s: string | null | undefined): string {
  return (s ?? '').trim().toLowerCase();
}

/** Прокси для префикса или null (нет рабочего с такой страной). */
export function pickProxyForPrefix(
  proxies: ReadonlyArray<TelegramProxy>,
  code: string
): TelegramProxy | null {
  const wanted = norm(code);
  if (!wanted) return null;
  let best: TelegramProxy | null = null;
  let bestLoad = Infinity;
  for (const p of proxies) {
    if (norm(p.country) !== wanted || p.last_check?.ok !== true) continue;
    const load = p.accounts?.length ?? 0;
    if (load < bestLoad) {
      best = p;
      bestLoad = load;
    }
  }
  return best;
}

/** Подсказка под выбором прокси, когда подобрать нечего. */
export function noProxyForPrefixHint(code: string): string {
  return `Нет рабочего прокси для ${code}`;
}
